import { useMemo } from 'react'
import { Modal, Space, Button } from '@arco-design/web-react'
import useLocale from '@/utils/useLocale'
import styles from './index.module.less'

const UpdateLog = (props: any) => {
  const { visible, setVisible, updateLogs } = props
  const t = useLocale()

  const logData = useMemo(
    () =>
      updateLogs?.description?.map?.((descItem: any, index: number) => {
        return {
          key: index + 1,
          data: descItem
        }
      }),
    [updateLogs]
  )

  const handleClose = () => {
    setVisible(false)
  }

  return (
    <Modal
      className={styles['updateLog']}
      title={
        <img
          src={'https://echosell-static.tos-cn-beijing.volces.com/assets/log.png'}
          alt=""
          className={styles['updateLog-icom']}
        />
      }
      visible={visible}
      onOk={async () => setVisible(false)}
      onCancel={() => setVisible(false)}
      autoFocus={false}
      focusLock={true}
      closable={false}
      footer={null}
      style={{ width: '680px' }}
    >
      <p className={styles['updateLog-title']}>
        {updateLogs?.title || t['update.log.title']}
        <span
          className={styles.version}
          onClick={() => {
            updateLogs?.changelog && window.open(updateLogs?.changelog)
          }}
        >
          v{updateLogs?.version}
        </span>
      </p>

      <div className={styles['updateLog-matter']}>
        {logData?.map((item: any) => (
          <div key={item.key} className={styles['updateLog-matter-item']}>
            <span className={styles['updateLog-matter-icon']}></span>
            <span className={styles['updateLog-matter-text']}>
              <span dangerouslySetInnerHTML={{ __html: item.data }}></span>
            </span>
          </div>
        ))}
      </div>
      {/* 按钮 */}
      <div className={styles['updateLog-footer']}>
        <Space size={'large'}>
          <Button
            type="outline"
            className={styles['updateLog-footer-discard']}
            onClick={() => {
              updateLogs?.changelog && window.open(updateLogs?.changelog)
              handleClose()
            }}
          >
            {t['update.log.discard']}
          </Button>
          <Button className={styles['updateLog-footer-now']} onClick={handleClose}>
            {t['update.log.update']}
          </Button>
        </Space>
      </div>
    </Modal>
  )
}

export default UpdateLog
